var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Period as PeriodModel } from '@/models/Period';
import PageHeader from '@/components/page-header/PageHeader';
import ErrorHandler from '@/support/ErrorHandler';
let Period = class Period extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Period';
        this.period = new PeriodModel();
        this.periodCache = {
            name: '',
            value: '',
            starts_at: '',
            ends_at: '',
        };
        this.isEditing = false;
        this.isEditingStartDate = false;
        this.isEditingEndDate = false;
    }
    mounted() {
        new PeriodModel().find(this.$route.params.id).then((period) => {
            this.period = period;
        });
    }
    get breadcrumbs() {
        return [{ name: 'Period', path: '/periods' }, { name: this.period.name || '', path: this.$route.path }];
    }
    createPeriodCache() {
        Object.keys(this.periodCache).forEach((key) => {
            this.periodCache[key] = this.period[key];
        });
    }
    cancelEdit() {
        Object.keys(this.periodCache).forEach((key) => {
            this.period[key] = this.periodCache[key];
        });
        this.isEditing = false;
    }
    update() {
        this.period
            .update()
            .then((period) => {
            this.period = period;
            this.isEditing = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
            this.isEditing = false;
        });
    }
};
Period = __decorate([
    Component({
        components: {
            PageHeader,
        },
    })
], Period);
export default Period;
